export default "__VITE_ASSET__C7eT_OAi__"